module.exports.version = 'v11.10.1-522f2acf';
